import React, { useState } from 'react';

const TermsOfService = () => {
  return (
    <div className="legal-page" style={{ backgroundColor: '#f4f6f8', paddingBottom: '6rem' }}>
      
      {/* INJECTED STYLES TO HIDE GLOBAL ARROWS */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
          .legal-hero::after {
            display: none !important;
          }
        `}
      </style>

      {/* Unified Hero */}
      <section className="legal-hero">
        <div className="container text-center">
          <h1>Terms of Service</h1>
          <p className="subtitle">
            The operational framework and conditions for our security deployments.
          </p>
        </div>
      </section>

      {/* Legal Content (Floating Document Card) */}
      <section className="legal-content container" style={{ position: 'relative', marginTop: '-80px', zIndex: 10 }}>
        <div className="legal-text-block" style={{ backgroundColor: 'var(--color-white)', padding: '4rem 8%', borderRadius: '16px', boxShadow: '0 20px 50px rgba(0,0,0,0.08)' }}>
          
          <div style={{ borderBottom: '1px solid rgba(0,0,0,0.05)', paddingBottom: '1.5rem', marginBottom: '3rem' }}>
            <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-grey)' }}>
              Last Updated: May 2026
            </p>
          </div>

          <h2>1. Application of Terms</h2>
          <p>
            These Terms of Service apply to the provision of all security and risk consultancy services by Nightmark Protective Services. By instructing us to commence services, you agree to be strictly bound by these terms.
          </p>

          <h2>2. Provision of Services</h2>
          <p>
            We agree to provide security services using reasonable care and skill, strictly in accordance with UK law, Security Industry Authority (SIA) regulations and the Approved Contractor Scheme (ACS) standards. We reserve the right to amend our operational deployment to ensure the safety of our personnel and clients.
          </p>

          <h2>3. Client Obligations</h2>
          <p>The Client shall:</p>
          <ul className="legal-list">
            <li>Provide safe and legal access to the premises where services are to be performed.</li>
            <li>Ensure all required risk assessments and site instructions are accurate and up to date.</li>
            <li>Not request our personnel to perform duties outside the scope of the agreed Service Level Agreement (SLA) or duties that breach UK law.</li>
          </ul>

          <h2>4. Personnel & Vetting</h2>
          <p>
            All Nightmark Protective Services personnel are vetted to BS7858 standards and hold valid SIA licences where applicable. The Client agrees not to directly employ, solicit or entice away any of our personnel during the contract term and for a period of 12 months following termination.
          </p>

          <h2>5. Liability and Indemnity</h2>
          <p>
            While we execute our duties with absolute vigilance, Nightmark Protective Services cannot guarantee the prevention of all loss, damage or criminal activity. Our liability in respect of any breach of duty or negligence shall be limited to the value of the specific service contract, except in cases of death or personal injury caused by our direct negligence.
          </p>

          <h2>6. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of England and Wales. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the English courts.
          </p>
        </div>
      </section>

    </div>
  );
};

export default TermsOfService;